export const LOCAL_AUTH_PATHS = {
  bootstrap: "/auth/bootstrap",
  login: "/auth/login",
  logout: "/auth/logout",
  refresh: "/auth/refresh",
  captcha: "/auth/captcha",
  me: "/auth/me",
  providerStatus: "/auth/provider-status",
  changePassword: "/auth/change-password",
  profile: "/auth/profile",
  profileAvatar: "/auth/profile/avatar",
  preferences: "/auth/preferences",
} as const;

export const LOCAL_AUTH_NON_REFRESHABLE_PATHS: ReadonlySet<string> = new Set([
  LOCAL_AUTH_PATHS.login,
  LOCAL_AUTH_PATHS.logout,
  LOCAL_AUTH_PATHS.refresh,
  LOCAL_AUTH_PATHS.captcha,
]);

export const SSO_AUTH_API_PATHS = {
  login: "/api/auth/login",
  logout: "/api/auth/logout",
  me: "/api/auth/me",
} as const;
